import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VAlert,{attrs:{"type":"error","prominent":""}},[_vm._v(" \n    The service is currently unavailable. "),_c(VBtn,{staticClass:"ml-5",attrs:{"depressed":"","to":{ name: 'home' }}},[_vm._v("Try Again!")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }